<template>
  <div id="app">
    <vue-topprogress ref="progressBar" color="#EC7004"></vue-topprogress>
    <router-view/>
  </div>
</template>

<script>
import { vueTopprogress } from 'vue-top-progress'
import {isLoggedIn} from "@/utils/authFunctions"
import { mapState, mapActions } from 'pinia'
import { useAuthStore } from '@/stores/auth'
import { useNavigationHistoryStore } from '@/stores/navigationHistory'

  export default {
    name: 'app',
    components: {vueTopprogress},
    created() {
        this.setErrMess('')
    },
    methods:{
      isLoggedIn,
      ...mapActions(useAuthStore, ['setPendingInvite','setErrMess','acceptInvite']),
      ...mapActions(useNavigationHistoryStore, ['updateLastUrl']),
    },
    computed:{
        ...mapState(useAuthStore, ['pendingInvite','current_user']),
    },
      watch: {
    '$route': function(to, from) {
        if(to !== from){
          this.updateLastUrl({'raw': to.path, 'params': to.params})
          if(this.pendingInvite !== null && this.isLoggedIn()){
              this.acceptInvite(this.pendingInvite)
            .then(resp => {
                    this.setPendingInvite(null)
                    if(resp['success']){
                        setTimeout(() => {
                                this.$bvToast.toast(resp['message'], {
                                    title: 'Sucesso!',
                                    toaster: 'b-toaster-bottom-right',
                                    solid: true,
                                    appendToast: true,
                                    noCloseButton: false,
                                    autoHideDelay: 6000,
                                    variant: 'success'
                                })
                            }, 750)
                    }else{
                         // setTimeout(() => {
                         //        this.$bvToast.toast(resp['message'], {
                         //            title: 'Error!',
                         //            toaster: 'b-toaster-bottom-right',
                         //            solid: true,
                         //            appendToast: true,
                         //            noCloseButton: false,
                         //            autoHideDelay: 6000,
                         //            variant: 'danger'
                         //        })
                         //    }, 750)
                    }
            })
          }
        }
    }
  }
  }
</script>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Public+Sans&display=swap');
  html{height:100%;}
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
    .b-toaster.b-toaster-bottom-right{
    bottom: 40px !important;
}
</style>
<style scoped>

</style>
